// Écran générique « à venir » utilisé pour les sections en construction.
import React from "react";
import { Construction } from "lucide-react";

export default function Placeholder({ titre }) {
  return (
    <div className="fenua-fade-up" data-testid="page-placeholder">
      <h1 data-testid="titre-section" className="text-3xl font-black tracking-tight text-[#1D3D3D]">
        {titre}
      </h1>
      <div className="mt-8 bg-white border border-dashed border-[#4A8A8A]/40 rounded-lg p-12 flex flex-col items-center justify-center text-center">
        <div className="h-14 w-14 rounded-full bg-[#E8F4F4] flex items-center justify-center mb-4">
          <Construction className="h-7 w-7 text-[#4A8A8A]" />
        </div>
        <h2 className="text-lg font-bold text-[#1D3D3D]">Section en construction</h2>
        <p className="mt-2 text-sm text-[#1D3D3D]/65 max-w-md">
          La section « {titre} » sera disponible prochainement. Elle est en cours
          de préparation pour vous offrir la meilleure expérience.
        </p>
      </div>
    </div>
  );
}
